// src/GlobalStyles.js
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.darkBlue};
    color: ${({ theme }) => theme.colors.white};
    margin: 0;
    padding: 0;
    font-family: "basic-sans", sans-serif;
    font-weight: "200";
  }

  .wizardContainer {
    background-color: rgba(30, 65, 255, .25);
    border-radius: 60px;
    padding: 50px;
    color: white;
  }

  input, textarea {
    color: #1A0B27;
  }

  .wizardInput label {
    color: white;
  }

  * {
    box-sizing: border-box;
  }

  /* Styles for ReactTagInput tags */
  .ReactTags__tag {
    background-color: #1e41ff; /* Custom background color */
    color: white; /* Custom text color */
    padding: 5px 20px 5px 20px;
    border-radius: 25px;
    font-family: "basic-sans";
    font-weight: 600;
    margin-right: 10px; /* Space between tags */
    display: inline-block;
  }

  .ReactTags__remove {
    margin-left: 10px;
    margin-right: -6px;
    cursor: pointer;
    color: white;
    font-weight: bold;
  }

  .ReactTags__tagInput {
    border: none;
    margin-top: 15px;
    margin-bottom: 15px;
    font-family: "basic-sans";
    font-weight: 300;
  }

  .ReactTags__tagInputField {
    border-radius: 5px;
    background-color: white;
    padding: 10px;
    font-family: "basic-sans";
    width: 100%;
  }
`;

export default GlobalStyles;
